import { createHashHistory } from 'history'
const history = createHashHistory()
export default history

// 监听路由
let routerLength = 0
history.listen((_: any, listener: any) => {
  if (listener === 'PUSH') {
    routerLength += 1
  } else if (listener === 'POP') {
    if (routerLength >= 1) routerLength -= 1
  }
})

// 详情页的返回按钮 如果没有上一级 才push
export const backPageFu = (url: string) => {
  console.log(routerLength)
  routerLength ? history.go(-1) : history.push(url)
}

// 判断是手机端还是pc端
export const isMobileFu = () => {
  if (
    window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true
  } else return false
}


